import React, { useState } from 'react';
import PropTypes from 'prop-types';

import './styles.scss';

export default function TradeReviewLayout({ leftPanel, rightPanel, navigationHeader }) {
    const [isLeftPanelCollapsed, setIsLeftPanelCollapsed] = useState(false);

    const toggleLeftPanel = () => {
        setIsLeftPanelCollapsed(!isLeftPanelCollapsed);
    };

    return (
        <div className="trade-review-layout">
            {/* Navigation Header - Previous/Next buttons */}
            <div className="trade-review-navigation">{navigationHeader}</div>

            {/* Two Panel Container */}
            <div className="trade-review-panels">
                {/* Left Panel - Collapsible */}
                <div
                    className={`trade-review-left-panel ${isLeftPanelCollapsed ? 'collapsed' : ''}`}
                >
                    {!isLeftPanelCollapsed && leftPanel}
                </div>

                {/* Right Panel - Expandable */}
                <div
                    className={`trade-review-right-panel ${isLeftPanelCollapsed ? 'expanded' : ''}`}
                >
                    {rightPanel(isLeftPanelCollapsed, toggleLeftPanel)}
                </div>
            </div>
        </div>
    );
}

TradeReviewLayout.propTypes = {
    leftPanel: PropTypes.node.isRequired,
    rightPanel: PropTypes.func.isRequired,
    navigationHeader: PropTypes.node
};
